var bookshelf = require("../index-extended");

module.exports = bookshelf.model("ResolutionCatalogTag", {
  entityName: "ResolutionCatalogTag",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "resolution_catalog_tag",
});
